export default __webpack_public_path__ + "static/media/Background_00255.a956decb.png";